// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBCvwhI-M1Z1EAfIrwjwfzcgIC7XpoLdug",
    authDomain: "corporate-sales-trainer-fc02b.firebaseapp.com",
    projectId: "corporate-sales-trainer-fc02b",
    storageBucket: "corporate-sales-trainer-fc02b.appspot.com",
    messagingSenderId: "602104600722",
    appId: "1:602104600722:web:35d3a4b4b4ae2ba95e2e4b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;